angular
  .module("admin.subscriptions")
  .controller(
    "SubscriptionsSummaryCtrl",
    function (SubscriptionListResource, $uibModal, $scope, CnpjUtils) {
      this.filter = {
        page: 1,
        limit: 10,
      };

      this.saveFilter = function () {
        const filter = angular.copy(this.filter);
        const json = JSON.stringify(filter);

        sessionStorage.setItem("admin.subscriptions.filter", json);
      };

      this.restoreFilter = function () {
        const json = sessionStorage.getItem("admin.subscriptions.filter");
        if (json) {
          const filter = JSON.parse(json);
          this.filter = filter;
          if (this.filter.cnpj) {
            this.filter.cnpj = CnpjUtils.normalize(this.filter.cnpj);
          }
        }
      };

      this.clear = function () {
        this.filter = {
          page: 1,
          limit: 10,
          cpf: "",
          cnpj: ""
        };

        if ($scope.frmFilters) {
          $scope.frmFilters.$setPristine();
          $scope.frmFilters.$setUntouched();
        }

        this.loadSubscriptions();
      };

      this.search = function () {
        if ($scope.frmFilters && $scope.frmFilters.$invalid) {
          return;
        }

        this.filter.page = 1;
        this.loadSubscriptions();
      };

      this.appliedFilters = {};

      this.hasSearchFilters = function () {
        return !!(
          this.appliedFilters.name ||
          this.appliedFilters.email ||
          this.appliedFilters.cpf
        );
      };

      this.loadSubscriptions = function () {
        this.saveFilter();

        const query = angular.copy(this.filter);
        if (query.cnpj) {
          query.cnpj = CnpjUtils.normalize(query.cnpj);
        }

        this.appliedFilters = query;

        SubscriptionListResource.query(
          query,
          (response) => {
            this.subscriptions = response.data;
          },
          (error) => {
            this.alerts = [
              {
                type: "danger",
                message: "Não foi possível trazer as assinaturas",
              },
            ];
          }
        );
      };

      this.openImportDialog = function () {
        $uibModal.open({
          templateUrl: "views/trial/trial.html",
          controller: "TrialCtrl",
          size: "lg",
          backdrop: "static",
          controllerAs: "ctrl",
        });
      };

      this.restoreFilter();
      this.loadSubscriptions();
    }
  )
  .config(function ($stateProvider) {
    $stateProvider.state("admin.subscriptions", {
      url: "subscriptions",
      controller: "SubscriptionsSummaryCtrl",
      controllerAs: "ctrl",
      templateUrl: "views/subscriptions/view.html",
      data: {
        permissions: {
          only: "admin.subscriptions",
        },
      },
    });
  });
